import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { setUser } from "../store/slices/authSlice";
import userApi from "../api/userApi";

export const useRestoreSession = () => {
    const dispatch = useDispatch();

    const { data: user, isSuccess, isLoading } = useQuery({
        queryKey: ["me"],
        queryFn: async () => {
            const res = await userApi.getUser();
            return res.data;
        },
        staleTime: 5 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (isSuccess && user) {
            dispatch(setUser(user));
        }
    }, [isSuccess, user, dispatch]);

    return { isLoading };
};
